import React from "react";
import { CircularProgress } from "@mui/material";

/**
 * @typedef {Object} RankData
 * @property {string} number
 * @property {string} name
 */

/**
 * RankBlock component
 * @param {Object} props
 * @param {string} props.className
 * @param {RankData[]} props.rankDataArray
 * @param {string} props.dateType
 * @param {React.Dispatch<React.SetStateAction<string>>} props.setDateType
 * @param {boolean} props.isLoading
 */
const RankBlock = ({
  className,
  rankDataArray = [],
  dateType,
  setDateType,
  isLoading,
}) => {
  return (
    <div className={"rank-block " + className}>
      <div className="rank-query">
        {["TODAY", "YESTERDAY", "WEEK", "MONTH"].map((_type) => (
          <div
            key={_type}
            className="rank-query-option"
            onClick={() => {
              if (!isLoading) setDateType(_type);
            }}
            style={{
              fontWeight: _type === dateType ? "bold" : "normal",
              cursor: isLoading ? "not-allowed" : "pointer",
            }}
          >
            {_type}
          </div>
        ))}
      </div>
      {isLoading && (
        <div className="rank-loader">
          <CircularProgress />
        </div>
      )}
      {rankDataArray.map((rankData, index) => (
        <div
          style={{
            visibility: isLoading ? "hidden" : "visible",
          }}
          key={rankData.name + rankData.number + index}
          className="rank-item"
        >
          <div className={`rank-number rank-number-${index}`}>
            {rankData.number}
          </div>
          <div className="rank-name">{rankData.name}</div>
        </div>
      ))}
      {rankDataArray.length < 1 && !isLoading && (
        <div className="rank-item">
          <div className="rank-number rank-number-0">0</div>
          <div className="rank-name"> --- </div>
        </div>
      )}
      {rankDataArray.length < 2 && !isLoading && (
        <div className="rank-item">
          <div className="rank-number rank-number-1">0</div>
          <div className="rank-name"> --- </div>
        </div>
      )}
      {rankDataArray.length < 3 && !isLoading && (
        <div className="rank-item">
          <div className="rank-number rank-number-2">0</div>
          <div className="rank-name"> --- </div>
        </div>
      )}
    </div>
  );
};

export default RankBlock;
